import React, { useCallback, useContext } from 'react';
import { MetaMaskContext } from '../metamask';
import { OwnSodabitsGrid } from '../grid';

import './modal.scss';


const ChooseSodabitModal = ({show=false, closeModal, onSelect}) => {

  if (!show) {
    return null;
  }

  return (<>
    <div className={`modal fade show`} tabIndex="-1" role="dialog" aria-labelledby="Choose a Sodabit" style={{display: 'block'}}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="h5 modal-title text-center w-100" > Choose a Sodabit </div>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span onClick={closeModal} aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body">
            <OwnSodabitsGrid onClick={onSelect}/>
          </div>

          <div className="modal-footer">
            <button type="button" onClick={closeModal} className="btn btn-primary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div onClick={closeModal} className={`modal-backdrop fade show`} style={{display: 'block'}}></div>
  </>);
};


export {
  ChooseSodabitModal,
};
